module.exports = __webpack_public_path__ + "img/footer_pic_logo@2x.a096ebaa.png";